<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>ประวัติการสมัคร</b></h5>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center">เลขที่ใบสมัคร</th>
                    <th style="text-align: left">กิจกรรม</th>
                    <th style="text-align: left">วันที่</th>
                    <th style="text-align: left">สถานะ</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_load_my_order === 'Y'">
                  <tr>
                    <td colspan="10">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_my_order.length !== 0">
                  <tr v-for="item in this.data_my_order" :key="item">
                    <td style="text-align: center"><a :href="'/order/' + item.uuid" target="_blank">{{ item.uuid }}</a>
                    </td>
                    <td style="text-align: left">{{ item.event_key }}</td>
                    <td style="text-align: left">{{ item.uuid }}</td>
                    <td style="text-align: left">{{ item.status }}</td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_my_order.length === 0">
                  <tr>
                    <td colspan="5">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      token: null,
      is_load_my_order: "N",
      data_my_order: [],
      _rr_user: null
    }
  },
  async created() {
    this.token = localStorage.getItem("_rr_token");
    if(this.token !== null){
      this.load_my_order();
    }else{
      //alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง")
      this.$router.push("/auth/login");
    }
  },
  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    this._rr_user = localStorage.getItem("_rr_user");
    if(this.token !== null){
      this.load_my_order();
    }else{
      //alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง")
      this.$router.push("/auth/login");
    }
  },
  methods: {
    async load_my_order() {
      this.is_load_my_order = "Y"
      this.data_my_order = [];
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      const res = await axios.post("/v1/member-event/order", null, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.data_my_order = res.data.body
        this.is_load_my_order = "N"
      } else {

        alert("พบข้อผิดพลาด")
        this.is_load_my_order = "N"
      }
    }
  }
};
</script>
